import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["title", "children", "open", "fullWidth", "maxWidth", "onClose", "disableBackdropClick", "hideCloseIcon", "DialogTitleProps"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//@ts-nocheck
import { Dialog as MuiDialog, useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import DialogTitle from "./DialogTitle";
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RoundedDialog = styled(MuiDialog)({
  "& .MuiPaper-root": {
    borderRadius: "16px" // Adjust the radius
  }
});
var Dialog = function Dialog(_ref) {
  var title = _ref.title,
    children = _ref.children,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? "md" : _ref$maxWidth,
    onClose = _ref.onClose,
    _ref$disableBackdropC = _ref.disableBackdropClick,
    disableBackdropClick = _ref$disableBackdropC === void 0 ? true : _ref$disableBackdropC,
    _ref$hideCloseIcon = _ref.hideCloseIcon,
    hideCloseIcon = _ref$hideCloseIcon === void 0 ? false : _ref$hideCloseIcon,
    _ref$DialogTitleProps = _ref.DialogTitleProps,
    DialogTitleProps = _ref$DialogTitleProps === void 0 ? {} : _ref$DialogTitleProps,
    dialogProps = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var modal = useMediaQuery(theme.breakpoints.up("lg"));
  var onCloseFunction = function onCloseFunction(event, reason) {
    if (disableBackdropClick) {
      if (reason !== "backdropClick") {
        onClose();
      }
    } else {
      onClose();
    }
  };
  return /*#__PURE__*/_jsxs(RoundedDialog, _objectSpread(_objectSpread({
    maxWidth: maxWidth,
    fullWidth: fullWidth,
    open: open,
    onClose: onCloseFunction
  }, dialogProps), {}, {
    fullScreen: !modal,
    children: [title && /*#__PURE__*/_jsx(DialogTitle, _objectSpread({
      title: title,
      onClose: onClose,
      hideCloseIcon: hideCloseIcon
    }, DialogTitleProps)), children]
  }));
};
export default Dialog;